'use client';

import { useEffect, useState } from 'react';
import { NotificationToast } from '../kit/NotificationToast';

export default function SessionExpiredToast() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleSessionExpired = (event) => {
      setMessage(event.detail.message);
      setOpen(true);
    };

    window.addEventListener('session-expired', handleSessionExpired);

    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, []);

  return (
    <NotificationToast
      open={open}
      title="Session Expired"
      message={message || 'Your session has expired. Please log in again to continue.'}
      severity="warning"
      onClose={() => setOpen(false)}
      actions={[
        {
          label: 'Login Again',
          onClick: () => {
            window.location.href = '/login';
          },
        },
      ]}
    />
  );
}
